import './tickets_by_user_view.js.coffee'
Namespace 'Customer.Ticket'

class Customer.Ticket.InternalTicketsByUserView extends Customer.Ticket.TicketsByUserView
  template: JST['backbone/templates/customer/ticket/tickets_by_user']
  className: 'tickets-by-user ticket-stats-box'
  events:
    'click .related-opened-tickets-count': 'onClickRelatedOpenedCount'
    'click .related-closed-tickets-count': 'onClickRelatedClosedCount'

  render: ->
    @$el.html @template
      thisUserHas: I18n.t('customer.dashboard.conversations.details.box.this_user_has')
      openedTickets: @_openedTicketsMessage() if @stats.opened_last_month_count
      closedTickets: @_closedTicketsMessage() if @stats.closed_last_month_count
      periodToCheck: @_periodToCheckMessage()
    @

  _openedTicketsMessage: ->
    @_translatedCount('customer.dashboard.conversations.details.box.opened_ticket', @stats.opened_last_month_count)

  _closedTicketsMessage: ->
    @_translatedCount('customer.dashboard.conversations.details.box.closed_ticket', @stats.closed_last_month_count)

  onClickRelatedOpenedCount: ->
    @trigger('opened:relatedOpenedTickets')

  onClickRelatedClosedCount: ->
    @trigger('opened:relatedClosedTickets')
